import { RouterProvider } from "@tanstack/react-router";
import { useQueryClient, useTRPC } from "./_app/api";
import { useConfig } from "./_app/config";
import { useIsFeatureEnabled } from "./_app/featureFlags";
import { useTranslation } from "./_app/i18n";
import { MaintenancePage } from "./maintenanceMode/MaintenancePage";
import { translations } from "./maintenanceMode/translations";
import { router } from "./router";

export function App() {
  const t = useTranslation(translations);
  const config = useConfig();
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const showMaintenancePage = useIsFeatureEnabled(
    "showMaintenancePageInTaxAdvisorPortal"
  );

  if (showMaintenancePage) {
    return <MaintenancePage message={t("message")} />;
  }

  return (
    <RouterProvider router={router} context={{ config, queryClient, trpc }} />
  );
}
